import React, { HTMLProps } from 'react';

import styles from './InfoBlock.module.scss';

export const InfoBlock = (props: HTMLProps<HTMLDivElement>) => {
	return (
		<div className={styles.infoBlockContainer}>
			<div className={styles.infoBlockContent}>{props.children}</div>
		</div>
	);
};
